export default __webpack_public_path__ + "static/media/success-icon.d71961c2.svg";